import React, { useState, useEffect, useRef, useContext, Children } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import 'moment/locale/ko';
import DropdownSelect from '../../components/DropdownSelect';
import { AuthContext } from '../../navigation/AuthProvider';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import { useToast } from '../../controller/ToastController';
import { useOutletContext } from 'react-router-dom';

const hourList: any = [
  { key:  0, value: '00', name: '00시', label: '00시' },
  { key:  1, value: '01', name: '01시', label: '01시' },
  { key:  2, value: '02', name: '02시', label: '02시' },
  { key:  3, value: '03', name: '03시', label: '03시' },
  { key:  4, value: '04', name: '04시', label: '04시' },
  { key:  5, value: '05', name: '05시', label: '05시' },
  { key:  6, value: '06', name: '06시', label: '06시' },
  { key:  7, value: '07', name: '07시', label: '07시' },
  { key:  8, value: '08', name: '08시', label: '08시' },
  { key:  9, value: '09', name: '09시', label: '09시' },
  { key: 10, value: '10', name: '10시', label: '10시' },
  { key: 11, value: '11', name: '11시', label: '11시' },
  { key: 12, value: '12', name: '12시', label: '12시' },
  { key: 13, value: '13', name: '13시', label: '13시' },
  { key: 14, value: '14', name: '14시', label: '14시' },
  { key: 15, value: '15', name: '15시', label: '15시' },
  { key: 16, value: '16', name: '16시', label: '16시' },
  { key: 17, value: '17', name: '17시', label: '17시' },
  { key: 18, value: '18', name: '18시', label: '18시' },
  { key: 19, value: '19', name: '19시', label: '19시' },
  { key: 20, value: '20', name: '20시', label: '20시' },
  { key: 21, value: '21', name: '21시', label: '21시' },
  { key: 22, value: '22', name: '22시', label: '22시' },
  { key: 23, value: '23', name: '23시', label: '23시' },
  // { key: 24, value: '24', name: '24시', label: '24시' },
];
const minuteList: any = [];

for (let i = 0; i < 24; i++) {




  // hourList.push({
  //   key: i,
  //   value: i > 9 ? `${i}` : `0${i}`,
  //   label: i > 9 ? `${i}시` : `0${i}시`,
  //   name: i > 9 ? `${i}시` : `0${i}시`,
  // });
}
for (let i = 0; i < 12; i++) {
  minuteList.push({
    key: i,
    value: i > 1 ? `${i * 5}` : `0${i * 5}`,
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const weekList: any = [
  { key: 0, value: 0, name: '일요일', label: '일요일' },
  { key: 1, value: 1, name: '월요일', label: '월요일' },
  { key: 2, value: 2, name: '화요일', label: '화요일' },
  { key: 3, value: 3, name: '수요일', label: '수요일' },
  { key: 4, value: 4, name: '목요일', label: '목요일' },
  { key: 5, value: 5, name: '금요일', label: '금요일' },
  { key: 6, value: 6, name: '토요일', label: '토요일' },
  { key: 7, value: 7, name: '매일', label: '매일' },
  { key: 8, value: 8, name: '평일', label: '평일' },
  { key: 9, value: 9, name: '주말', label: '주말' },
];

const dayList: any = [
  weekList[1],
  weekList[2],
  weekList[3],
  weekList[4],
  weekList[5],
  weekList[6],
  weekList[0],
];

const eachDayList: any = [weekList[7], weekList[8], weekList[9]];

type workDateType = {
  day_of_week: number;
  opening_time: string;
  closing_time: string;
  type: number;
};

type periodType = {
  startTime: any;
  endTime: any;
};

const StoreTime = () => {
  const moment = require('moment');
  const weekFormat = 'dddd HH:mm';
  const timeFormat = 'HH:mm';

  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [workWeek, setWorkWeek] = useState<number>(7);
  const [workStartHour, setWorkStartHour] = useState<string>('00');
  const [workStartMin, setworkStartMin] = useState<string>('00');
  const [workEndHour, setWorkEndHour] = useState<string>('00');
  const [workEndMin, setworkEndMin] = useState<string>('00');

  const [breakWeek, setBreakWeek] = useState<number>(7);
  const [breakStartHour, setBreakStartHour] = useState<string>('00');
  const [breakStartMin, setBreakStartMin] = useState<string>('00');
  const [breakEndHour, setBreakEndHour] = useState<string>('00');
  const [breakEndMin, setBreakEndMin] = useState<string>('00');

  const [workDateType, setWorkDateType] = useState<number>(0);
  const [workDate, setWorkDate] = useState<workDateType[]>([]);

  const [breakDateType, setBreakDateType] = useState<number>(0);
  const [breakDate, setBreakDate] = useState<workDateType[]>([]);

  const [endHourList, setEndHourList] = useState<any>([]);
  const [breakEndHourList, setBreakEndHourList] = useState<any>([]);

  const showToast = useToast();

  // endHour에 대한 리스트 받기
  const getEndHourList = (hour: string) => {
    let listTemp = [];
    for (let i = parseInt(hour); i < 24 + 10; i++) {
      if (i > 24)
        listTemp.push({
          key: i % 24,
          value: i > 9 ? `${i}` : `0${i}`,
          label: i % 24 > 9 ? `다음날 ${i % 24}시` : `다음날 0${i % 24}시`,
          name: i % 24 > 9 ? `다음날 ${i % 24}시` : `다음날 0${i % 24}시`,
        });
      else {
        listTemp.push({
          key: i,
          value: i > 9 ? `${i}` : `0${i}`,
          label: i > 9 ? `${i}시` : `0${i}시`,
          name: i > 9 ? `${i}시` : `0${i}시`,
        });
      }
    }
    if (parseInt(hour) === 0)
      listTemp.push({
        key: 24,
        value: `24`,
        label: `24시`,
        name: `24시`,
      });
    setEndHourList([...listTemp]);
  };
  const getBreakEndHourList = (hour: string) => {
    let listTemp = [];
    for (let i = parseInt(hour); i < 24 + 10; i++) {
      if (i > 24)
        listTemp.push({
          key: i % 24,
          value: i > 9 ? `${i}` : `0${i}`,
          label: i % 24 > 9 ? `다음날 ${i % 24}시` : `다음날 0${i % 24}시`,
          name: i % 24 > 9 ? `다음날 ${i % 24}시` : `다음날 0${i % 24}시`,
        });
      else {
        listTemp.push({
          key: i,
          value: i > 9 ? `${i}` : `0${i}`,
          label: i > 9 ? `${i}시` : `0${i}시`,
          name: i > 9 ? `${i}시` : `0${i}시`,
        });
      }
    }
    setBreakEndHourList([...listTemp]);
  };

  // API 호출에 대한 형식으로 리스트 변환
  const getWorkDateList = (item: workDateType, type: number) => {
    const dayListTemp: workDateType[] = [];

    if (item.day_of_week === 8) {
      for (let i = 1; i < 6; i++) {
        if (moment(item.opening_time, timeFormat) >= moment(item.closing_time, timeFormat)) {
          dayListTemp.push({
            day_of_week: i,
            opening_time: item.opening_time,
            closing_time: '00:00:00',
            type: type,
          });
          dayListTemp.push({
            day_of_week: (i + 1) % 7,
            opening_time: '00:00:00',
            closing_time: item.closing_time,
            type: type,
          });
        } else {
          dayListTemp.push({
            day_of_week: i,
            opening_time: item.opening_time,
            closing_time: item.closing_time,
            type: type,
          });
        }
      }
    } else if (item.day_of_week === 9) {
      if (moment(item.opening_time, timeFormat) >= moment(item.closing_time, timeFormat)) {
        console.log('big?');
        dayListTemp.push({
          day_of_week: 6,
          opening_time: item.opening_time,
          closing_time: '00:00:00',
          type: type,
        });
        dayListTemp.push({
          day_of_week: 0,
          opening_time: '00:00:00',
          closing_time: item.closing_time,
          type: type,
        });
        dayListTemp.push({
          day_of_week: 0,
          opening_time: item.opening_time,
          closing_time: '00:00:00',
          type: type,
        });
        dayListTemp.push({
          day_of_week: 1,
          opening_time: '00:00:00',
          closing_time: item.closing_time,
          type: type,
        });
      } else {
        dayListTemp.push({
          day_of_week: 6,
          opening_time: item.opening_time,
          closing_time: item.closing_time,
          type: type,
        });
        dayListTemp.push({
          day_of_week: 0,
          opening_time: item.opening_time,
          closing_time: item.closing_time,
          type: type,
        });
      }
    }
    return dayListTemp;
  };

  // StartTime, EndTime에 대한 dddd HH:mm formatting
  const getTimeMoment = (date: workDateType, isStart: boolean) => {
    if (moment(date.opening_time, timeFormat) >= moment(date.closing_time, timeFormat)) {
      if (isStart) {
        return moment(
          `${date.day_of_week < 7 ? getWeekLabel(date.day_of_week) : ''} ${date.opening_time}`,
          weekFormat,
        );
      } else
        return moment(
          `${date.day_of_week < 7 ? getWeekLabel((date.day_of_week + 1) % 7) : ''} ${
            date.closing_time
          }`,
          weekFormat,
        ).add(date.day_of_week === 6 ? 7 : 0, 'days');
    } else {
      if (isStart) {
        return moment(
          `${date.day_of_week < 7 ? getWeekLabel(date.day_of_week) : ''} ${date.opening_time}`,
          weekFormat,
        );
      } else
        return moment(
          `${date.day_of_week < 7 ? getWeekLabel(date.day_of_week) : ''} ${date.closing_time}`,
          weekFormat,
        );
    }
  };

  // 매일, 평일, 주말, 요일에 대한 날짜리스트
  const getDayList = (item: workDateType) => {
    const dayList: periodType[] = [];

    if (item.day_of_week === 7) {
      for (let i = 0; i < 7; i++) {
        let targetTemp = JSON.parse(JSON.stringify(item));
        targetTemp.day_of_week = i;
        dayList.push({
          startTime: getTimeMoment(targetTemp, true),
          endTime: getTimeMoment(targetTemp, false),
        });
      }
    } else if (item.day_of_week === 8) {
      for (let i = 1; i < 6; i++) {
        let targetTemp = JSON.parse(JSON.stringify(item));
        targetTemp.day_of_week = i;
        dayList.push({
          startTime: getTimeMoment(targetTemp, true),
          endTime: getTimeMoment(targetTemp, false),
        });
      }
    } else if (item.day_of_week === 9) {
      let targetTemp = JSON.parse(JSON.stringify(item));
      targetTemp.day_of_week = 6;
      dayList.push({
        startTime: getTimeMoment(targetTemp, true),
        endTime: getTimeMoment(targetTemp, false),
      });
      targetTemp.day_of_week = 0;
      dayList.push({
        startTime: getTimeMoment(targetTemp, true),
        endTime: getTimeMoment(targetTemp, false),
      });
    } else {
      dayList.push({
        startTime: getTimeMoment(item, true),
        endTime: getTimeMoment(item, false),
      });
    }
    console.log('dayList', dayList);
    return dayList;
  };

  // 시간대 체크
  const checkWorkDate = (target: workDateType, workDate: workDateType[]) => {
    const targetTimes = getDayList(target);

    let checkDate = false;
    if (workDate.length === 0) {
      checkDate = true;
      return checkDate;
    }

    for (let i = 0; i < workDate.length; i++) {
      let itemTimes: periodType[] = getDayList(workDate[i]);

      console.log('time', itemTimes, 'target', targetTimes);

      for (let j = 0; j < targetTimes.length; j++) {
        for (let k = 0; k < itemTimes.length; k++) {
          console.log('sp', targetTimes[j], itemTimes[k]);
          if (
            targetTimes[j].startTime >= itemTimes[k].endTime &&
            targetTimes[j].endTime >= itemTimes[k].endTime
          ) {
            console.log('after endTime');
            checkDate = true;
          } else if (
            targetTimes[j].startTime <= itemTimes[k].startTime &&
            targetTimes[j].endTime <= itemTimes[k].startTime
          ) {
            console.log('before startTime');
            checkDate = true;
          } else {
            console.log('incorrect', targetTimes[j], itemTimes[k], j, k);
            checkDate = false;
            return checkDate;
          }
        }
      }
    }

    return checkDate;
  };

  // workTime 추가, 삭제
  const addWorkDate = () => {
    
    

    // showToast(`${workWeek} ${workStartHour},${workEndHour}`);
    
    // return;
    const workDataTemp: workDateType = {
      day_of_week: workWeek,
      opening_time: `${workStartHour}:${workStartMin}:00`,
      // closing_time: `${workEndHour === '24' ? '00' : workEndHour}:${workEndMin}:00`,
      closing_time: `${workEndHour}:${workEndMin}:00`,
      type: 1,
    };

    if(parseInt(workStartHour) > parseInt(workEndHour) ||
    (
      parseInt(workStartHour) == parseInt(workEndHour) &&
      parseInt(workStartMin) >= parseInt(workEndMin)
    )){
      showToast('영업마감시간을 확인해주세요', 'error');
      return;
    }

    setWorkDate([...workDate, workDataTemp]);

    // if (
    //   workStartHour === '00' &&
    //   workEndHour === '24' &&
    //   workStartMin === '00' &&
    //   workEndMin === '00'
    // ) {
    //   if (checkWorkDate(workDataTemp, workDate)) {
    //     setWorkDate([...workDate, workDataTemp]);
    //   } else showToast('중복되는 시간이 존재해요.', 'error');
    // } else if (workStartHour === workEndHour && workStartMin === workEndMin) {
    //   console.log('same');
    //   showToast('시작시간과 종료시간이 같아요.', 'error');
    // } else if (workStartHour === workEndHour && workStartMin > workEndMin) {
    //   console.log('fast');
    //   showToast('종료시간이 시작시간보다 빨라요.', 'error');
    // } else {
    //   if (checkWorkDate(workDataTemp, workDate)) {
    //     if (workWeek === 8 || workWeek === 9) {
    //       setWorkDate([...workDate, ...getWorkDateList(workDataTemp, 1)]);
    //     } else {
    //       setWorkDate([...workDate, workDataTemp]);
    //     }
    //   } else {
    //     showToast('중복되는 시간이 존재해요.', 'error');
    //   }
    // }
  };

  const deleteWorkDate = (index: number) => {
    workDate.splice(index, 1);
    setWorkDate([...workDate]);
  };

  // breakTime 추가, 삭제
  const addBreakDate = () => {
    const workDataTemp: workDateType = {
      day_of_week: breakWeek,
      opening_time: `${breakStartHour}:${breakStartMin}:00`,
      closing_time: `${breakEndHour}:${breakEndMin}:00`,
      type: 0,
    };

    if(parseInt(breakStartHour) > parseInt(breakEndHour) ||
    (
      parseInt(breakStartHour) == parseInt(breakEndHour) &&
      parseInt(breakStartMin) >= parseInt(breakEndMin)
    )){
      showToast('휴게종료시간을 확인해주세요', 'error');
      return;
    }

    setBreakDate([...breakDate, workDataTemp]);

    // if (breakStartHour === breakEndHour && breakStartMin === breakEndMin) {
    //   console.log('same');
    //   showToast('시작시간과 종료시간이 같아요.', 'error');
    // } else if (breakStartHour === breakEndHour && breakStartMin > breakEndMin) {
    //   console.log('fast');
    //   showToast('종료시간이 시작시간보다 빨라요.', 'error');
    // } else {
    //   if (checkWorkDate(workDataTemp, breakDate)) {
    //     if (breakWeek === 8 || breakWeek === 9) {
    //       setBreakDate([...breakDate, ...getWorkDateList(workDataTemp, 0)]);
    //     } else {
    //       setBreakDate([...breakDate, workDataTemp]);
    //     }
    //   } else {
    //     showToast('마감 시간이 더 이르거나 중복되는 시간이 존재해요.', 'error');
    //   }
    // }
  };
  // 삭제하기
  const deleteBreakDate = (index: number) => {
    breakDate.splice(index, 1);
    setBreakDate([...breakDate]);
  };

  // 요일 label 반환
  const getWeekLabel = (weekValue: number) => {
    return weekList.find((week: any) => week.value === weekValue).label;
  };

  // 요일, 시간
  const onChange_workWeek = (e: any) => {
    setWorkWeek(e.value);
  };
  const onChange_workStartHour = (e: any) => {
    setWorkStartHour(e.value);
    getEndHourList(e.value);
  };
  const onChange_workStartMin = (e: any) => {
    setworkStartMin(e.value);
  };
  const onChange_workEndHour = (e: any) => {
    setWorkEndHour(e.value);
  };
  const onChange_workEndMin = (e: any) => {
    setworkEndMin(e.value);
  };
  const onChange_breakWeek = (e: any) => {
    setBreakWeek(e.value);
  };
  const onChange_breakStartHour = (e: any) => {
    setBreakStartHour(e.value);
    getBreakEndHourList(e.value);
  };
  const onChange_breakStartMin = (e: any) => {
    setBreakStartMin(e.value);
  };
  const onChange_breakEndHour = (e: any) => {
    setBreakEndHour(e.value);
  };
  const onChange_breakEndMin = (e: any) => {
    setBreakEndMin(e.value);
  };

  // 영업시간 type
  const onChangeOpenType = (value: number) => {
    if (value === 0) setWorkWeek(7);
    else setWorkWeek(1);
    setWorkDateType(value);
  };
  const onChangeBreakType = (value: number) => {
    if (value === 0) setBreakWeek(7);
    else setBreakWeek(1);
    setBreakDateType(value);
  };

  // API 호출
  const getBusinessTime = async () => {
    try {
      const oRes: any = await StoreController.getBusinessTime(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log('res', oResponse);

        if (oResponse.data) {
          setWorkDate([...oResponse.data.work_time]);
          setBreakDate([...oResponse.data.break_time]);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const setBusinessTime = async () => {
    try {
      if (workDate.length > 0) {
        const oRes: any = await StoreController.setBusinessTime(
          currentStore.value,
          workDate,
          breakDate,
        );

        if (oRes && oRes.data) {
          const oResponse: any = oRes.data;
          console.log('res', oResponse);
          if (oResponse.ok) {
            showToast('운영시간을 변경했어요.');
          }
        }
      } else {
        showToast('운영시간을 추가해주세요.', 'error');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getBusinessTime();
    getEndHourList('00');
    getBreakEndHourList('00');
  }, [currentStore]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="contentWrap">
            <div className="title initial">
              <h4>영업시간</h4>
            </div>
            <div className="title initial">
              {workDate.length > 0 ? (
                <div className="dayList">
                  {workDate.map((item: workDateType, index: number) => {
                    return (
                      <div className="dayItem" key={index}>
                        <div className="itemWeek">{getWeekLabel(item.day_of_week)}</div>
                        <div className="itemTime">{`${item.opening_time.slice(0, -3)} ~ ${
                          (parseInt(item.closing_time.slice(0, 2)) >= 25 ? 
                          `다음날 0${parseInt(item.closing_time.slice(0, 2))%24}:${item.closing_time.slice(3, 5)}`:
                          `${item.closing_time.slice(0, -3)}` 
                          )
                        }`}</div>
                        <div className="itemDelete">
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                            onClick={() => deleteWorkDate(index)}
                            alt="ic"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="dayList">
                  <div className="noneList">영업시간을 추가해주세요</div>
                </div>
              )}
            </div>
            <div className="title">
              <h5>영업시간 추가</h5>
            </div>
            <div className="selectBoxWrap">
              <div
                className={`selectBox left ${workDateType === 0 && 'active'}`}
                onClick={() => onChangeOpenType(0)}>
                매일 같아요 / 주말,평일만 달라요
              </div>
              <div
                className={`selectBox right ${workDateType === 1 && 'active'}`}
                onClick={() => onChangeOpenType(1)}>
                요일별로 모두 달라요
              </div>
            </div>
            <div className="selectWrap">
              <div className="selectDateWrap">
                <div className="dateSelect">
                  <DropdownSelect
                    options={workDateType === 0 ? eachDayList : dayList}
                    defaultValue={workDateType === 0 ? eachDayList[0] : dayList[0]}
                    onChangeValue={onChange_workWeek}
                  />
                </div>
              </div>
              <div className="selectDateWrap">
                <div className="dateSelect">
                  <DropdownSelect
                    options={hourList}
                    defaultValue={hourList[0]}
                    onChangeValue={onChange_workStartHour}
                  />
                </div>
                <div className="dateSelect">
                  <DropdownSelect
                    options={minuteList}
                    defaultValue={minuteList[0]}
                    onChangeValue={onChange_workStartMin}
                  />
                </div>
                ~
                <div className="dateSelect">
                  <DropdownSelect
                    options={endHourList}
                    defaultValue={endHourList.length > 0 ? endHourList[0] : hourList[0]}
                    onChangeValue={onChange_workEndHour}
                  />
                </div>
                <div className="dateSelect">
                  <DropdownSelect
                    options={minuteList}
                    defaultValue={minuteList[0]}
                    onChangeValue={onChange_workEndMin}
                  />
                </div>
              </div>
            </div>
            <button className="addButton" onClick={addWorkDate}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
              <h5>영업시간 추가하기</h5>
            </button>
          </div>
        </div>
        <div className="contentContainer">
          <div className="contentWrap">
            <div className="title initial">
              <h4>휴게시간</h4>
            </div>
            <div className="title initial">
              {breakDate.length > 0 ? (
                <div className="dayList">
                  {breakDate.map((item: workDateType, index: number) => {
                    return (
                      <div className="dayItem" key={index}>
                        <div className="itemWeek">{getWeekLabel(item.day_of_week)}</div>
                        <div className="itemTime">{`${item.opening_time.slice(
                          0,
                          -3,
                        )} ~ ${
                          (parseInt(item.closing_time.slice(0, 2)) >= 25 ? 
                          `다음날 0${parseInt(item.closing_time.slice(0, 2))%24}:${item.closing_time.slice(3, 5)}`:
                          `${item.closing_time.slice(0, -3)}` 
                          )
                        }`}</div>
                        <div className="itemDelete">
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                            onClick={() => deleteBreakDate(index)}
                            alt="ic"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="dayList">
                  <div className="noneList">휴게시간을 추가해주세요</div>
                </div>
              )}
            </div>
            <div className="title">
              <h5>휴게시간 추가</h5>
            </div>
            <div className="selectBoxWrap">
              <div
                className={`selectBox left ${breakDateType === 0 && 'active'}`}
                onClick={() => onChangeBreakType(0)}>
                매일 같아요 / 주말,평일만 달라요
              </div>
              <div
                className={`selectBox right ${breakDateType === 1 && 'active'}`}
                onClick={() => onChangeBreakType(1)}>
                요일별로 모두 달라요
              </div>
            </div>
            <div className="selectWrap">
              <div className="selectDateWrap">
                <div className="dateSelect">
                  <DropdownSelect
                    options={breakDateType === 0 ? eachDayList : dayList}
                    defaultValue={breakDateType === 0 ? eachDayList[0] : dayList[0]}
                    onChangeValue={onChange_breakWeek}
                  />
                </div>
              </div>
              <div className="selectDateWrap">
                <div className="dateSelect">
                  <DropdownSelect
                    options={hourList}
                    defaultValue={hourList[0]}
                    onChangeValue={onChange_breakStartHour}
                  />
                </div>
                <div className="dateSelect">
                  <DropdownSelect
                    options={minuteList}
                    defaultValue={minuteList[0]}
                    onChangeValue={onChange_breakStartMin}
                  />
                </div>
                ~
                <div className="dateSelect">
                  <DropdownSelect
                    options={breakEndHourList}
                    defaultValue={breakEndHourList.length > 0 ? breakEndHourList[0] : hourList[0]}
                    onChangeValue={onChange_breakEndHour}
                  />
                </div>
                <div className="dateSelect">
                  <DropdownSelect
                    options={minuteList}
                    defaultValue={minuteList[0]}
                    onChangeValue={onChange_breakEndMin}
                  />
                </div>
              </div>
            </div>
            <button className="addButton" onClick={addBreakDate}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
              <h5>브레이크타임 추가하기</h5>
            </button>
          </div>
          <button
            className={`submitButton ${workDate.length === 0 && 'inactive'}`}
            onClick={setBusinessTime}>
            영업시간 등록하기
          </button>
        </div>
      </Style>
    </>
  );
};

export default StoreTime;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  h4 {
    color: #555555;
  }
  .row.gap10 {
    flex: 1;
  }

  .title {
    padding: 20px 0 0 0;

    h5 {
      color: #555555;
      padding-bottom: 6px;
    }
  }
  .title.initial {
    padding: 0 0 6px 0;
  }
  .contentWrap {
    padding-bottom: 4%;
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding-bottom: 20px;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  .dayList {
    border: 1px solid #cecece;
    border-radius: 5px;
    .dayItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 20px;
      border-bottom: 1px solid #f7f7f7;
      border-radius: 5px;
      color: #555555;
      .itemWeek {
        flex: 2;
      }
      .itemTime {
        flex: 3;
        text-align: center;
      }
      .itemDelete {
        flex: 2;
        text-align: right;
      }
    }

    .noneList {
      text-align: left;
      padding: 17.5px 30px;
      color: #979797;
    }
  }

  .selectWrap {
    width: 100%;
    padding-bottom: 14px;
  }

  .selectDateWrap {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #979797;

    .dateSelect {
      flex: 1;
    }
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 20px;

    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  @media (max-width: 900px) {
    .selectBoxWrap {
      .selectBox {
        font-size: 11px;
      }
    }
  }
`;
